<div class="responsive-card d-flex flex-column gap-4">
  <div class="responsive-card-title" i18n>Recurring Payment Details</div>
  <ng-container *ngIf="annualHasChanged || monthlyHasChanged || newRecurringPaymentsForgone">
    <div class="d-flex flex-column gap-2">
      <span class="status-label" i18n>Current</span>
      <div class="d-flex flex-column gap-3">
        <app-vb-payment-change-submission-recurring-payment
          [changeType]="VbRecurringPaymentChangeTypeEnum.Current"
          [hasChanged]="
            (monthlyHasChanged && !newRecurringPaymentsForgone) ||
            (newRecurringPaymentsForgone && !submittedAfterCutoffDate)
          "
          [frequency]="VariableBenefitPaymentFrequencyEnum.Monthly"
          [activeRecurringPaymentInstruction]="previousActiveMonthlyRecurringPaymentInstruction"
          [scheduledRecurringPaymentInstruction]="previousScheduledMonthlyRecurringPaymentInstruction" />
        <app-vb-payment-change-submission-recurring-payment
          [changeType]="VbRecurringPaymentChangeTypeEnum.Current"
          [frequency]="VariableBenefitPaymentFrequencyEnum.Annually"
          [hasChanged]="
            (annualHasChanged && !newRecurringPaymentsForgone) ||
            (newRecurringPaymentsForgone && !submittedAfterCutoffDate)
          "
          [activeRecurringPaymentInstruction]="previousActiveAnnualRecurringPaymentInstruction"
          [scheduledRecurringPaymentInstruction]="previousScheduledAnnualRecurringPaymentInstruction" />
      </div>
    </div>
    <div class="d-flex flex-column gap-2">
      <span class="status-label" i18n>New</span>
      <app-vb-scheduled-change-notice *ngIf="scheduledChangeNotices.length" [notices]="scheduledChangeNotices" />
      <ng-container *ngIf="!newRecurringPaymentsForgone">
        <div class="d-flex flex-column gap-3">
          <app-vb-payment-change-submission-recurring-payment
            [changeType]="VbRecurringPaymentChangeTypeEnum.New"
            [frequency]="VariableBenefitPaymentFrequencyEnum.Monthly"
            [hasChanged]="monthlyHasChanged"
            [activeRecurringPaymentInstruction]="displayNewActiveMonthlyRecurringPaymentInstruction"
            [scheduledRecurringPaymentInstruction]="displayNewScheduledMonthlyRecurringPaymentInstruction" />
          <app-vb-payment-change-submission-recurring-payment
            [changeType]="VbRecurringPaymentChangeTypeEnum.New"
            [frequency]="VariableBenefitPaymentFrequencyEnum.Annually"
            [hasChanged]="annualHasChanged"
            [activeRecurringPaymentInstruction]="displayNewActiveAnnualRecurringPaymentInstruction"
            [scheduledRecurringPaymentInstruction]="displayNewScheduledAnnualRecurringPaymentInstruction" />
        </div>
      </ng-container>
      <ng-container *ngIf="newRecurringPaymentsForgone">
        <div class="forgo-recurring-payments-container" i18n>
          The recurring payments will cease in {{ paymentCeaseDate }}
        </div>
      </ng-container>
    </div>
  </ng-container>

  <ng-container *ngIf="!annualHasChanged && !monthlyHasChanged && !newRecurringPaymentsForgone">
    <div class="d-flex flex-column gap-3">
      <app-vb-payment-change-submission-recurring-payment
        [hasChanged]="false"
        [frequency]="VariableBenefitPaymentFrequencyEnum.Monthly"
        [activeRecurringPaymentInstruction]="previousActiveMonthlyRecurringPaymentInstruction"
        [scheduledRecurringPaymentInstruction]="previousScheduledMonthlyRecurringPaymentInstruction" />
      <app-vb-payment-change-submission-recurring-payment
        [hasChanged]="false"
        [frequency]="VariableBenefitPaymentFrequencyEnum.Annually"
        [activeRecurringPaymentInstruction]="previousActiveAnnualRecurringPaymentInstruction"
        [scheduledRecurringPaymentInstruction]="previousScheduledAnnualRecurringPaymentInstruction" />
    </div>
  </ng-container>
</div>
